<template>
  <base-modal :visible="visible" :width="width" @close="$emit('close')">
    <template #title>
      <i class="fas fa-edit"></i>
      <span>{{ title }}</span>
    </template>

    <c-f-input
      ref="search"
      v-model="query"
      icon="fas fa-search"
      placeholder="Поиск..."
    />

    <button
      v-if="showRepairAction"
      type="button"
      class="picker__repair-action"
      @click="$emit('repair'); $emit('close')"
    >
      <i class="fas fa-wrench"></i> Отправить машину на ремонт
    </button>

    <div class="picker__list" ref="list">
      <template v-if="filtered.length">
        <button
          v-for="(opt, idx) in filtered"
          :key="optKey(opt) != null ? optKey(opt) : idx"
          type="button"
          class="picker__item"
          :class="{ 'picker__item--selected': isSelected(opt) }"
          @click="$emit('select', opt); $emit('close')"
        >
          {{ optLabel(opt) }}
        </button>
      </template>
      <div v-else class="picker__empty u-text-secondary" >Ничего не найдено</div>
    </div>

    <template #footer>
      <app-button variant="ghost" class="picker__cancel" @click="$emit('close')">
        Отмена
      </app-button>
    </template>
  </base-modal>
</template>

<script>
export default {
  name: 'PickerModal',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: 'Выбор' },
    // Элемент options может быть строкой либо объектом { id, name }.
    options: { type: Array, default: () => [] },
    value: { type: [String, Object], default: '' },
    width: { type: String, default: '400px' },
    showRepairAction: { type: Boolean, default: false }
  },
  data() {
    return { query: '' }
  },
  computed: {
    filtered() {
      const q = this.query.trim().toLowerCase()
      if (!q) return this.options
      return this.options.filter(o => this.optLabel(o).toLowerCase().includes(q))
    }
  },
  methods: {
    optLabel(opt) {
      if (!opt) return ''
      return typeof opt === 'object' ? (opt.name || '') : opt
    },
    optKey(opt) {
      if (!opt) return null
      return typeof opt === 'object' ? (opt.id != null ? opt.id : null) : opt
    },
    isSelected(opt) {
      if (!this.value) return false
      if (typeof opt === 'object') {
        return typeof this.value === 'object' ? opt.id === this.value.id : false
      }
      return opt === this.value
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.query = ''
        this.$nextTick(() => {
          if (this.$refs.search && this.$refs.search.$el) {
            const input = this.$refs.search.$el.querySelector('input')
            if (input) input.focus()
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.picker__repair-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-6);
  width: 100%;
  margin-top: var(--space-8);
  padding: var(--space-6) var(--space-8);
  border: var(--border-width-default) var(--border-style-base) var(--warning);
  border-radius: var(--radius-md);
  background: var(--warning-soft);
  color: var(--warning-text);
  font-family: inherit;
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: background var(--duration-fast) var(--ease-base);
}
.picker__repair-action:hover { background: var(--warning); color: var(--text-on-dark); }

.picker__list {
  margin-top: var(--space-12);
  max-height: 300px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--space-0-5);
}

.picker__item {
  text-align: left;
  padding: var(--space-5) var(--space-8);
  cursor: pointer;
  border: none;
  border-radius: var(--radius-md);
  background: transparent;
  font-size: var(--text-base);
  color: var(--text-primary);
  transition: background var(--duration-fast) var(--ease-base);
}
.picker__item:hover { background: var(--bg-selected); }
.picker__item--selected { background: var(--bg-selected); font-weight: var(--font-weight-medium); }

.picker__empty {
  padding: var(--space-5) var(--space-8);
  font-style: italic;
  font-size: var(--text-base);
}

.picker__cancel { width: 100%; }
</style>
